<template>
  <div class="membership-badges-wrap">
    <div class="user-badges-overview">
      <h2 class="has-text-weight-bold is-size-4 font-color has-text-centered pb10">My Badges</h2>
      <div class="earned-badges-overview relative">
        <div class="earned-badges-overview-content">
            <ul :class="displayAllBadges ? 'active' : ''">
            <li  v-bind:key="index + 'user_badge'" v-for="(badge, index) in vg_userLoyalityEarnedBagdes" :class="(index+1) <= itemToDisplay ? '': 'hide'">
                <div class="badge-item pointer" @click="showEarnedBadgeModal(badge)">
                  <figure class="text-center badge-icon">
                    <img v-if="badge.badge && badge.badge.icon_url" :src="badge.badge.icon_url" :alt="badge.badge.desc"/>
                    <img v-else src="@/assets/img/badge-icon.svg" alt="badge" />
                    <span v-if="badge.badge.no_of_times_repeatable && badge.badge.no_of_times_repeatable > 1 " class="badge-repeat-tag">{{ badge.no_of_times_earned ? badge.no_of_times_earned : 0 }}/{{badge.badge.no_of_times_repeatable}}</span>
                  </figure>
                  <!-- <p>
                    <span class="badge-tag">EXCLUSIVE</span>
                  </p> -->
                  <div class="badge-detail-excerpt">
                    <p class="is-size-14 has-text-weight-medium">{{ badge.badge.name }}</p>
                    <p class="is-size-10px">{{ readableFormat(badge.badge_earned_date) }}</p>
                  </div>
                </div>
            </li>
            <li :class="(vg_userLoyalityEarnedBagdes.length >= itemToDisplay) ? 'hide' : '' ">
                <div class="badge-item">
                  <figure class="text-center badge-icon">
                    <img  src="@/assets/img/whatnext.png" alt="badge" />
                  </figure>
                  <div class="badge-detail-excerpt">
                    <p class="is-size-14 has-text-weight-medium">Your Next Quest!</p>
                    <p class="is-size-10px">NOW</p>
                  </div>
                </div>
            </li>
          </ul>

          <span v-if="displayMoreBadges" :class="'show-mode-badges'+ (displayAllBadges ? ' all-shown' : '')" @click="displayAllBadges = !displayAllBadges">
            <svg width="20" height="12" viewBox="0 0 20 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1.86844 0.165038L0.0984382 1.93504L9.99844 11.835L19.8984 1.93504L18.1284 0.165039L9.99844 8.29504L1.86844 0.165038V0.165038Z" fill="#008767"/>
            </svg>
          </span>
        </div>
        <span class="show-mode-badges-shade" v-if="displayMoreBadges"></span>
      </div>
    </div>

    <div class="membership-badges-content customscrollbar" v-if="vg_userLoyalityBagdes.length > 0">
      <div class="relative">
        <h2 class="has-text-weight-bold is-size-4 font-color has-text-centered pb10">In Progress</h2>
        <div class="badge-mobile-sort-filter has-inner-svg-secondary is-hidden-tablet" @click="openFlyoutBadgeFilter()">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M18.6667 7.99902H16V-0.000976562H18.6667V2.66569H24V5.33236H18.6667V7.99902ZM0 5.33236V2.66569H13.3333V5.33236H0ZM0 21.3324V18.6657H8V21.3324H0ZM13.3333 23.999V21.3324H24V18.6657H13.3333V15.999H10.6667V23.999H13.3333ZM5.33333 10.6657V7.99902H8V15.999H5.33333V13.3324H0V10.6657H5.33333ZM24 13.3324V10.6657H10.6667V13.3324H24Z" fill="white"/>
          </svg>
        </div>
      </div>
      <div class="is-flex justify-content-between align-items-center badges-filters mb20 is-hidden-mobile">
        <badges-filter-main :filters="filters"/>
      </div>
     
      <div class="loyality-point-transection-history customscrollbar">
        <item v-for="badge in notEarnedBadgesList" :badge="badge" v-bind:key="badge.id"/>
        <p class="is-size-14 text-center" v-if="notEarnedBadgesList.length == 0">Sorry no badges found.</p>
      </div>
      
      <!-- <div class="badge-pagination-wrap mb-60">
        <div class="badge-pagination-divider bg-secondary"></div>
          <div class="badge-pagination-wrapper">
            <div class="badge-pagination-content">
            <swiper
              ref="swiper"
              :slides-per-view="5"
              :scrollbar="{ draggable: false }"
              :loop="false"
              :navigation="nav"
              :initialSlide="1"
              :slidesPerGroup="2"
              :freeMode="true"
              :spaceBetween="8"
              :observer="true"
              :observeParents="true"
            >
              <swiper-slide
                v-bind:key="'badge_paginate'+item" 
                v-for="item in 9" 
              >
                <div :class="'badge-page-item' + (activePage == item ? ' active' : '')">
                  <a href="#" @click.prevent="navigateToPage(item)" class="has-text-weight-semibold is-size-6">
                    {{ item }}
                  </a>
                </div>
              </swiper-slide>
            </swiper>
            <div class="badges-pagination-arrow arrow-prev reverse-arrow hover-opacity-7" @click="prev">
              <svg width="9px" height="14px" viewBox="0 0 9 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <g id="-" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g id="cat_items_arrrow_right" transform="translate(-1226.000000, -808.000000)" fill="#302F30">
                        <g id="Group-6-Copy" transform="translate(1215.000000, 800.000000)">
                            <g id="Icon/Arrow/Line/Left" transform="translate(15.000000, 14.750000) scale(-1, 1) translate(-15.000000, -14.750000) translate(10.000000, 8.000000)">
                                <g id="Arrow" transform="translate(4.537500, 7.012500) scale(-1, 1) rotate(-90.000000) translate(-4.537500, -7.012500) translate(-2.062500, 2.887500)">
                                    <path d="M10.519789,-2.19557262 C10.2187806,-2.53690706 9.69818904,-2.57012988 9.3562172,-2.26982878 L2.75439107,3.50565068 C2.57676033,3.66227594 2.475,3.88765691 2.475,4.12445205 C2.475,4.36124719 2.57676033,4.58662816 2.75439107,4.74325342 L9.3562172,10.5187329 C9.5066598,10.6513855 9.70027764,10.7247114 9.90086785,10.725 C10.1378958,10.7246999 10.3633507,10.6225135 10.519789,10.4444767 C10.8201483,10.1025711 10.7869191,9.58208031 10.4455185,9.28113014 L4.55338869,4.12445205 L10.4455185,-1.03222604 C10.7869191,-1.33317621 10.8201483,-1.85366698 10.519789,-2.19557262 Z" id="Path" transform="translate(6.600000, 4.125000) scale(-1, 1) rotate(-90.000000) translate(-6.600000, -4.125000) "></path>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
              </svg>
            </div>
            <div class="badges-pagination-arrow arrow-next hover-opacity-7" @click="next">
              <svg width="9px" height="14px" viewBox="0 0 9 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <g id="-" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g id="cat_items_arrrow_right" transform="translate(-1226.000000, -808.000000)" fill="#302F30">
                        <g id="Group-6-Copy" transform="translate(1215.000000, 800.000000)">
                            <g id="Icon/Arrow/Line/Left" transform="translate(15.000000, 14.750000) scale(-1, 1) translate(-15.000000, -14.750000) translate(10.000000, 8.000000)">
                                <g id="Arrow" transform="translate(4.537500, 7.012500) scale(-1, 1) rotate(-90.000000) translate(-4.537500, -7.012500) translate(-2.062500, 2.887500)">
                                    <path d="M10.519789,-2.19557262 C10.2187806,-2.53690706 9.69818904,-2.57012988 9.3562172,-2.26982878 L2.75439107,3.50565068 C2.57676033,3.66227594 2.475,3.88765691 2.475,4.12445205 C2.475,4.36124719 2.57676033,4.58662816 2.75439107,4.74325342 L9.3562172,10.5187329 C9.5066598,10.6513855 9.70027764,10.7247114 9.90086785,10.725 C10.1378958,10.7246999 10.3633507,10.6225135 10.519789,10.4444767 C10.8201483,10.1025711 10.7869191,9.58208031 10.4455185,9.28113014 L4.55338869,4.12445205 L10.4455185,-1.03222604 C10.7869191,-1.33317621 10.8201483,-1.85366698 10.519789,-2.19557262 Z" id="Path" transform="translate(6.600000, 4.125000) scale(-1, 1) rotate(-90.000000) translate(-6.600000, -4.125000) "></path>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
              </svg>
            </div>
          </div>
        </div>
      </div> -->
    </div>

    <div class="membership-badges-content" v-else>
      <h2 class="has-text-weight-bold is-size-4 font-color has-text-centered pb10">No Badges</h2>
      <p class="has-text-centered mt10">Sorry no record found.</p>
    </div>

    <badges-mobile-footer-actions :filters="filters"/>
    <earned-badge-modal/>
  </div>
</template>


<script>
import Env from '@/env';
import Helpers from '@/Components/Helpers/Helpers';
import { mapGetters, mapActions } from "vuex";
import { format } from "date-fns";
import Item from '@/Components/Pages/User/Membership/BadgesItem';
import BadgesFilterMain from '@/Components/Pages/User/Membership/BadgesFilterMain';
import BadgesMobileFooterActions from '@/Components/Pages/User/Membership/BadgesMobileFooterActions';
import EarnedBadgeModal from '@/Components/Pages/User/Membership/EarnedBadgeModal';
import moment from 'moment';
import { SwiperCore, Swiper, SwiperSlide } from 'swiper-vue2'
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper';
SwiperCore.use([Navigation, Pagination])

export default {
  components: {
    Item,
    BadgesFilterMain,
    BadgesMobileFooterActions,
    EarnedBadgeModal,
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      loadingBadges: false,
      displayMoreBadges: false,
      displayAllBadges: false,
      itemToDisplay: 3,
      filters: {
        sort: 'low',
        type: [],
      },
      activePage: 1,
      nav: {
        nextEl: ".arrow-next",
        prevEl: ".arrow-prev",
      },
    }
  },

  
  computed: {
    ...mapGetters({
      vg_userId: "getLoggedInUserId",
      vg_businessProfile: "businessprofile/detail", 
      vg_selectedStore: "location/selected", 
      vg_userLoyalitySubscriptionObj: "userloyalitysubscription/obj",
      vg_userLoyalityEarnedBagdes: "userloyalitysubscription/earnedBadges",
      vg_userLoyalityNotEarnedBagdes: "userloyalitysubscription/notEarnedBadges",
      vg_userLoyalityBagdes: "userloyalitysubscription/badges",
    }),

    notEarnedBadgesList() {
      if(this.filters.type.length > 0){
        let filteredData = this.vg_userLoyalityNotEarnedBagdes.filter( item => {
          if(item.badge.upcoming){
            return item;
          } 
        });
        return filteredData;
      }
      return this.vg_userLoyalityNotEarnedBagdes;
    },

  },
  
  beforeDestroy() { 
    window.removeEventListener('resize', this.onResize); 
  },

  async mounted() {
    this.onResize();
    window.addEventListener('resize', this.onResize);
    this.va_setUserLoyalityObj({
      user_id: this.vg_userId, 
      business_id: this.vg_businessProfile.id,
    });
  },

  methods: {
    prev() {
      if(this.$refs.swiper.$swiper){
        this.$refs.swiper.$swiper.slidePrev()
      }
    },

    next() {
      if(this.$refs.swiper.$swiper){
        this.$refs.swiper.$swiper.slideNext()
      }
    },

    navigateToPage(page) {
      console.log(page)
      this.activePage = page;
    },
    /**
     * Show earned badge
     */
    showEarnedBadgeModal(badge) {
      bus.$emit('show-modal-user-earned-badge', {
        modal: true,
        badge,
      })
    },
    /**
     * handle reseize
     */
   onResize() {
    this.itemToDisplay = window.innerWidth > 768 ? 4 : 2;
    // if more than 4 always visible
    if(this.vg_userLoyalityEarnedBagdes.length > 3) {
      this.displayMoreBadges = true;  
    } else if(this.vg_userLoyalityEarnedBagdes.length > 1) {
      // if more than 2 and less then 4. on mobile need to show for desktop hide
      this.displayMoreBadges = window.innerWidth > 768 ? false : true;  
    } else {
      // less than 2 no visible
      this.displayMoreBadges = false;  
    }
   },

    // Create readable date format
   readableFormat(fulldate) {
      if (_.isEmpty(fulldate)) return;
      let receivedAt = moment(fulldate);
      return receivedAt.format('DD/MM/YYYY');
   },

    // Open flyout badge filter
    openFlyoutBadgeFilter() {
      bus.$emit('open-badge-flyout-filter', 2); // 2 because 2 is filter screen in flyout
    },

    ...mapActions({
      va_setUserLoyalityObj: "userloyalitysubscription/setUserLoyalityObj",
      va_spinner: "spinner/setSpinner",
      va_snackbar: "snackbar/setSnackbar",
    })
  },
};
</script>
